import React, {Component, Fragment} from 'react'
import {Form, InputNumber, Button, message,} from 'antd';
import OrderFileComponent from "../../components/bus/order-file"
import {DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR} from "../../utills/constants";
import {reqUpdateVolume} from "../../api";
let orderId;
class OrderFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: "",
        }
    }

    componentDidMount() {
        if (this.props.location.state) {
            orderId = this.props.location.state.orderId;
            this.setState({orderId})
        }
    }

    saveData = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            const {orderId,} = this.state;
            if (!err) {
                values.id = orderId;
                this.update(values);
            }
        });
    };
    update = async (po) => {
        const result = await reqUpdateVolume(po);
        if (result.code === 200) {
            message.success(result.message);
        } else {
            message.error(result.message);
        }
    };

    render() {
        const {deliveryType, subType, volume, boxInfo} = this.props;
        const {getFieldDecorator,} = this.props.form;
        const notBRequired = deliveryType === 'D'
            || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'B')
            || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType);//亚欧直达、特快且倒装运输、空运
        return (<Fragment>
                {notBRequired ?
                    <Form layout='inline'>
                        <Form.Item label="货物体积(CBM)">
                            {getFieldDecorator('volume', {
                                initialValue: boxInfo.volume ? boxInfo.volume : volume,
                                rules: [{required: true, message: '该项必填'}]
                            })(<InputNumber min={0} precision={2} step={1} style={{width: '100%'}}/>)}
                        </Form.Item>
                        <Form.Item label="货物重量(kg)">
                            {getFieldDecorator('goodsWeight', {
                                initialValue: boxInfo.goodsWeight,
                                rules: [{required: true, message: '该项必填'}]
                            })(<InputNumber min={0} precision={2} step={1} style={{width: '100%'}}/>)}
                        </Form.Item>
                        <Form.Item>
                            <Button type='primary' onClick={this.saveData}>保存</Button>
                        </Form.Item>
                    </Form>
                    : null}
                <OrderFileComponent {...this.props}/>
            </Fragment>
        )
    }
}
const OrderFileForm = Form.create()(OrderFile);
export default  OrderFileForm;